import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Spin, Card, Select } from 'antd'
import { Link, Redirect } from 'react-router-dom'
import { getFormGraphData } from '../../store/action/feedback.action'
import { useWindowsSize, Home as HomeComponents } from '../../component'
import PropTypes from 'prop-types'
import moment from 'moment'
import util from '../../util/util'
import '../../css/home.scss'
import serviceInterface from '../../services/service.interface'
import {
  getLast7Activities,
  getLast7Measurements,
  getStats,
} from '../../store/action/patient.action'

var { Buttons, BarChart, GraphData } = HomeComponents

const Home = (props) => {
  const ref = useRef(null)
  const [width, setWidth] = useState(undefined)
  const [range, setRange] = useState(1)
  const [activityrange, setactivityRange] = useState(7)

  const size = useWindowsSize()

  useEffect(() => {
    props.getLastActivities(
      props.customer?._id,
      moment().subtract('d', activityrange).toDate()
    )
    props.getLastMeasurements(
      props.customer?._id,
      moment().subtract('d', activityrange).toDate()
    )
  }, [activityrange])

  useEffect(() => {
    props.getStats()
  }, [])

  useEffect(() => {
    props.getGraphData(
      props.customer?._id,
      moment().subtract('M', range).toDate()
    )
  }, [range])

  useEffect(() => {
    var wdth = ref.current ? ref.current.offsetWidth : 0
    setWidth(Math.floor(wdth / 3.3))
  }, [ref.current, size.width])

  var {
    oks,
    pain,
    rom,
    activity: { skipped, partial, complete },
    measurement: { measkipped, meapartial, meacomplete },
    //stats: { knee, hip, active }
  } = props

  const activityRangePicker = (
    <Select
      showSearch
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      className='rangePicker'
      defaultValue={1}
      value={activityrange}
      onChange={(v) => setactivityRange(v)}
    >
      <Select.Option value={1}>Last 1 day</Select.Option>
      <Select.Option value={3}>Last 3 days</Select.Option>
      <Select.Option value={7}>Last 1 Week</Select.Option>
      <Select.Option value={15}>Last 15 days</Select.Option>
      <Select.Option value={30}>Last 1 month</Select.Option>
      <Select.Option value={60}>Last 2 month</Select.Option>
      <Select.Option value={90}>Last 3 month</Select.Option>
      <Select.Option value={182}>Last 6 month</Select.Option>
      <Select.Option value={365}>Last 1 Year</Select.Option>
    </Select>
  )
  return props.token == undefined ? (
    <Redirect to='/login' />
  ) : (
    <>
      <Spin spinning={props.isLoading}>
        <Row type='flex' className='homeContainer'>
          <div ref={ref} style={{ width: '100%' }}>
            <Row style={{ display: 'none' }}>
              <Col flex={'60%'}>
                <Card title='Card Title'>
                  <Card.Grid className='gridStyle'>Content</Card.Grid>
                  <Card.Grid hoverable={false} className='gridStyle'>
                    Content
                  </Card.Grid>
                  <Card.Grid className='gridStyle'>Content</Card.Grid>
                  <Card.Grid className='gridStyle'>Content</Card.Grid>
                  <Card.Grid className='gridStyle'>Content</Card.Grid>
                  <Card.Grid className='gridStyle'>Content</Card.Grid>
                </Card>
              </Col>
              <Col flex={'40%'}>
                <Card
                  title='PATIENT ENGAGEMENT'
                  bordered={false}
                  align='center'
                  className='chartContainer activityCard'
                >
                  <Row
                    className='chartContainer'
                    align='middle'
                    style={{ marginBottom: 10 }}
                  >
                    <Col flex='100px'>
                      <h3 style={{ margin: 0 }}>Range: </h3>
                    </Col>
                    <Col>{activityRangePicker}</Col>
                  </Row>
                  <Row style={{ marginBottom: 5 }}>
                    <Card.Grid className='gridStyle'>
                      <Link
                        className='home-link'
                        to={{ pathname: '/patient', state: { type: 'active' } }}
                      >
                        <Card
                          size='small'
                          bordered={false}
                          style={{ backgroundColor: '#1890ff' }}
                          title={props.stats?.active}
                          align='center'
                        />
                        {'Active Patients'}
                      </Link>
                    </Card.Grid>
                    <Card.Grid className='gridStyle'>
                      <Link
                        className='home-link'
                        to={{ pathname: '/patient', state: { type: 'active' } }}
                      >
                        <Card
                          size='small'
                          bordered={false}
                          style={{ backgroundColor: '#1890ff' }}
                          title={props.stats?.knee}
                          align='center'
                        />
                        {'Knee Patients'}
                      </Link>
                    </Card.Grid>

                    <Card.Grid className='gridStyle'>
                      <Link
                        className='home-link'
                        to={{ pathname: '/patient', state: { type: 'active' } }}
                      >
                        <Card
                          size='small'
                          bordered={false}
                          style={{ backgroundColor: '#1890ff' }}
                          title={props.stats?.hip}
                          align='center'
                        />
                        {'Hip Patients'}
                      </Link>
                    </Card.Grid>
                  </Row>
                  <Row style={{ marginBottom: 5 }}>
                    <Card.Grid className='gridStyle'>
                      <Link
                        className='home-link'
                        to={{
                          pathname: '/patient',
                          state: {
                            patientids: skipped,
                            name: ' Patients not following the m the exercise schedule',
                          },
                        }}
                      >
                        <Card
                          size='small'
                          bordered={false}
                          style={{ backgroundColor: 'red' }}
                          title={skipped?.length == 0 ? '0' : skipped?.length}
                          align='center'
                        />
                        {skipped?.length == 1 ? 'Patient is' : 'Patients are'}
                        <b> not following </b>exercise
                      </Link>
                    </Card.Grid>
                    <Card.Grid className='gridStyle'>
                      <Link
                        className='home-link'
                        to={{
                          pathname: '/patient',
                          state: {
                            patientids: partial,
                            name: 'Patients partially following the exercise schedule',
                          },
                        }}
                      >
                        <Card
                          size='small'
                          bordered={false}
                          style={{ backgroundColor: 'yellow' }}
                          title={partial?.length == 0 ? '0' : partial?.length}
                          align='center'
                        />
                        {partial?.length == 1 ? 'Patient is' : 'Patients are'}
                        <b> partially following </b>exercise
                      </Link>
                    </Card.Grid>

                    <Card.Grid className='gridStyle'>
                      <Link
                        className='home-link'
                        to={{
                          pathname: '/patient',
                          state: {
                            patientids: complete,
                            name: 'Patient completely followed the exercise schedule',
                          },
                        }}
                      >
                        <Card
                          size='small'
                          bordered={false}
                          style={{ backgroundColor: 'green' }}
                          title={complete?.length == 0 ? '0' : complete?.length}
                          align='center'
                        />
                        {complete?.length == 1 ? 'Patient is' : 'Patients are'}{' '}
                        <b>completely followed </b>exercise
                      </Link>
                    </Card.Grid>
                  </Row>
                  <Card.Grid className='gridStyle'>
                    <Link
                      className='home-link'
                      to={{
                        pathname: '/patient',
                        state: {
                          patientids: measkipped,
                          name: ' Patients not following the measurement schedule',
                        },
                      }}
                    >
                      <Card
                        size='small'
                        bordered={false}
                        style={{ backgroundColor: 'red' }}
                        title={
                          measkipped?.length == 0 ? '0' : measkipped?.length
                        }
                        align='center'
                      />
                      {measkipped?.length == 1 ? 'Patient is' : 'Patients are'}
                      <b> not following </b>measurement
                    </Link>
                  </Card.Grid>
                  <Card.Grid className='gridStyle'>
                    <Link
                      className='home-link'
                      to={{
                        pathname: '/patient',
                        state: {
                          patientids: meapartial,
                          name: 'Patients partially following the measurement schedule',
                        },
                      }}
                    >
                      <Card
                        size='small'
                        bordered={false}
                        style={{ backgroundColor: 'yellow' }}
                        title={
                          meapartial?.length == 0 ? '0' : meapartial?.length
                        }
                        align='center'
                      />
                      {meapartial?.length == 1 ? 'Patient is' : 'Patients are'}
                      <b> partially following </b> measurement
                    </Link>
                  </Card.Grid>
                  <Card.Grid className='gridStyle'>
                    <Link
                      className='home-link'
                      to={{
                        pathname: '/patient',
                        state: {
                          patientids: meacomplete,
                          name: 'Patient completely followed the measurement schedule',
                        },
                      }}
                    >
                      <Card
                        size='small'
                        bordered={false}
                        style={{ backgroundColor: 'green' }}
                        title={
                          meacomplete?.length == 0 ? '0' : meacomplete?.length
                        }
                        align='center'
                      />
                      {meacomplete?.length == 1 ? 'Patient is' : 'Patients are'}
                      <b> completely followed </b> measurement
                    </Link>
                  </Card.Grid>
                </Card>
              </Col>

              {/*<Buttons /> */}
            </Row>
            <Row
              className='chartContainer'
              align='middle'
              style={{ marginBottom: 24, marginTop: 24 }}
            >
              <Col flex='130px'>
                <h3 style={{ margin: 0 }}>SURVEY RANGE: </h3>
              </Col>
              <Col>
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  className='rangePicker'
                  defaultValue={1}
                  value={range}
                  onChange={(v) => setRange(v)}
                >
                  <Select.Option value={1}>Last 1 month</Select.Option>
                  <Select.Option value={2}>Last 2 month</Select.Option>
                  <Select.Option value={3}>Last 3 month</Select.Option>
                </Select>
              </Col>
            </Row>
            <Row justify='space-between' style={{ marginBottom: 24 }}>
              <Col>
                <center>
                  <h4>
                    Total {oks?.total}{' '}
                    {oks?.total == 1 ? 'response' : 'responses'}
                  </h4>
                </center>
                <Row className='chartContainer'>
                  {oks?.data && width && (
                    <BarChart data={oks.data} width={width} />
                  )}
                </Row>
                <center>
                  <h3>{oks?.name}</h3>
                </center>
              </Col>
              <Col>
                <center>
                  <h4>
                    Total {pain?.total}{' '}
                    {pain?.total == 1 ? 'response' : 'responses'}
                  </h4>
                </center>
                <Row className='chartContainer'>
                  {pain?.data && width && (
                    <BarChart data={pain.data} width={width} />
                  )}
                </Row>
                <center>
                  <h3>{pain?.name}</h3>
                </center>
              </Col>
              <Col>
                <center>
                  <h4>
                    Total {rom?.total}{' '}
                    {rom?.total == 1 ? 'response' : 'responses'}
                  </h4>
                </center>
                <Row className='chartContainer'>
                  {rom?.data && width && (
                    <BarChart data={rom.data} width={width} />
                  )}
                </Row>
                <center>
                  <h3>{rom?.name}</h3>
                </center>
              </Col>
            </Row>
          </div>
        </Row>
      </Spin>
    </>
  )
}

Home.propTypes = {
  isLoading: PropTypes.bool,
  token: PropTypes.string,
  customer: PropTypes.object,
  rom: PropTypes.object,
  pain: PropTypes.object,
  oks: PropTypes.object,
  activity: PropTypes.object,
  measurement: PropTypes.object,
  stats: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    isLoading: state.profile.isLoading,
    customer: state.profile.customer,
    oks: state.feedback.oks,
    pain: state.feedback.pain,
    rom: state.feedback.rom,
    activity: state.patient.activity,
    measurement: state.patient.measurement,
    stats: state.patient.stats,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getGraphData: (customerid, date) =>
      dispatch(getFormGraphData(customerid, date)),
    getLastActivities: (customerid, date) =>
      dispatch(getLast7Activities(customerid, date)),
    getLastMeasurements: (customerid, date) =>
      dispatch(getLast7Measurements(customerid, date)),
    getStats: () => dispatch(getStats()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
